import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Avatar, { AvatarSize, AvatarStatus } from '../../../components/Avatar';
import IconButton from '../../../components/IconButton';
import { getAllProfiles } from '../../../services/profiles';
import NotificationPopUp from '../NotificationPopUp/NotificationPopUp';
import ProfilePopover from '../ProfilePopover/ProfilePopover';

const TopNavBar: React.FC<{ onClick?: React.MouseEventHandler }> = ({
  onClick,
}) => {
  const navigate = useNavigate();
  const [mainUser] = getAllProfiles().data.filter(
    (profile) => profile.relationship === 'self'
  );

  return (
    <Container
      fluid
      className={'cnd-top-navigation p-0 m-0 position-sticky top-0 start-0'}
    >
      <div
        className={
          'pt-7 pt-lg-10 pb-1 px-3 pb-lg-10 px-lg-11 m-0 d-flex justify-content-between align-items-center'
        }
      >
        <div
          className={
            'cnd-top-navigation cnd-top-navigation--logo-wrapper d-flex align-items-center'
          }
        >
          <FontAwesomeIcon
            icon={light('bars')}
            className={'d-block d-lg-none ps-3 pe-4 pt-5 pb-3'}
            onClick={onClick}
          />
          <div
            className={'logo d-none d-lg-block'}
            onClick={() => navigate('/dashboard')}
          >
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="conduent-logo"
              height={48}
            />
          </div>
        </div>
        <div
          className={
            'cnd-top-navigation cnd-top-navigation--user-wrapper pe-3 pe-lg-0 d-flex align-items-center'
          }
        >
          <NotificationPopUp placement={'bottom-end'}>
            <IconButton variant="status" icon={light('bell')} isStatusButton />
          </NotificationPopUp>
          <ProfilePopover
            data={mainUser}
            currentPersona={mainUser.personas ? mainUser.personas[0]?.id : ''}
          >
            <Nav.Link>
              <Avatar
                id={'a-1'}
                size={AvatarSize.SMALL}
                image={mainUser.image}
                status={AvatarStatus.ENABLED}
                name={'Pat Simons'}
              />
            </Nav.Link>
          </ProfilePopover>
        </div>
      </div>
    </Container>
  );
};

export default TopNavBar;
